var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_419_83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2135 46.0024C26.1047 48.3325 21.8952 48.3325 18.7865 46.0024L3.90681 34.8494C0.798103 32.5193 -0.502702 28.389 0.684718 24.6188L6.36827 6.57282C7.55569 2.80262 10.9612 0.25 14.8038 0.25H33.1962C37.0388 0.25 40.4443 2.80262 41.6317 6.57283L47.3153 24.6188C48.5027 28.389 47.2019 32.5193 44.0932 34.8494L29.2135 46.0024Z",
    fill: "url(#paint0_linear_419_83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3863 45.2022L4.50658 34.0492C1.74545 31.9796 0.575589 28.2942 1.63853 24.9192L7.32208 6.87323C8.38355 3.50295 11.4148 1.25 14.8038 1.25H33.1962C36.5852 1.25 39.6165 3.50295 40.6779 6.87323L46.3615 24.9192C47.4244 28.2942 46.2545 31.9796 43.4934 34.0492L28.6137 45.2022C25.8604 47.2659 22.1396 47.2659 19.3863 45.2022Z",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_419_83",
    x: 0.25,
    y: 0.25,
    width: 47.5,
    height: 48.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.300741 0 0 0 0 0.171852 0 0 0 0 0.0192593 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_419_83"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_419_83",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_419_83",
    x1: 24.0006,
    y1: 49.9101,
    x2: 24.0006,
    y2: -4.99284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F07E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F4CF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.42e85b5318534259b7679157c4af2e4e.svg";
export { ForwardRef as ReactComponent };